export default __webpack_public_path__ + "static/media/aws.08dffd14.png";